$(document).ready(() => {
  $("#BT5 .top-video").on("click", function () {
      var video = $(this).find("video")[0];
        if (video.muted) {
            video.muted = false;
            $(this).find(".mute-icon").removeClass("hidden");
            $(this).find(".muted-icon").addClass("hidden");
        } else {
            video.muted = true;
            $(this).find(".mute-icon").addClass("hidden");
            $(this).find(".muted-icon").removeClass("hidden");
        }
    });

    // video slider
    $('#BT5 .KSS .videos-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '.prev_arrow',
      nextArrow: '.next_arrow',
      cssEase: 'ease',
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            cssEase: 'ease',
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            cssEase: 'ease',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });

    // slick slider
    $("#BT5 .KSS .videos-slider .video-slide .play-button").on("click", function () {
      $("#BT5 .KSS .videos-slider .video-slide video").each(function(){
        $(this).get(0).pause();
        $("#BT5 .KSS .videos-slider .video-slide .play-button").show();
      });
      $(this).siblings("video")[0].play();
      $(this).hide();
    });
    // Optional: Pause the video when it ends
    $("#BT5 .KSS .videos-slider .video-slide video").on("click", function (){
      $(this).siblings(".play-button").show();
      $(this).get(0).pause();
    });

    // FAQS
    // $(".FAQS .set .qstn").on("click", function() {
    //     $(this).siblings(".content").slideToggle();
    //     $(this).find("i").toggleClass("fa-minus fa-plus");
    //     $(".FAQS .set .qstn").not(this).next(".content").slideUp();
    //     $(".FAQS .set .qstn").not(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    // });

    $("#BT5 .IWA .accordion-item .item-header").click(function (e) { 
      e.preventDefault();
      $(this).find(".chevron").toggleClass("open");
      $(this).siblings(".desc-a").slideToggle();
    });

    // ATC
    $("#BT5 .PDS .atc-btn.change-btn-text").text($("#BT5 .PDS .block-wrapper-subs.selected").attr('atc-text'));
    $("#BT5 .PDS .hide-flavors .variant-selector").click(function(e){
      e.preventDefault();
      $("#BT5 .PDS .variant-selector").removeClass("selected");
      $(this).addClass("selected");
      $("#BT5 .PDS .atc-btn.change-btn-text").text($("#BT5 .PDS .block-wrapper-subs.selected").attr('atc-text'));
      var variantPrice = $(".one-time-"+$(this).attr("variant-type")).attr("var-price");
      var variantPriceSubs = $(".subscription-"+$(this).attr("variant-type")).attr("var-price");
      var servingPrice = $(".one-time-"+$(this).attr("variant-type")).attr("serving-price");
      var servingPriceSubs = $(".subscription-"+$(this).attr("variant-type")).attr("serving-price");
      $("#BT5 .PDS .block-wrapper-subs .prices .sub-text .subscription-serving-price").text(servingPriceSubs);
      $("#BT5 .PDS .block-wrapper-subs .prices .sub-text .serving-price").text(servingPrice);
      $("#BT5 .PDS .prod-price .o-price").text(variantPriceSubs);
      $("#BT5 .PDS .prod-price .subscription-otp-price").text(variantPrice);
      $("#BT5 .PDS .prod-price.one-time").text(variantPrice);

      $("#BT5 .KXL-PDP .product-text .off-text .off-text-percent-value").text($(".subscription-"+$(this).attr("variant-type")).attr("off-text"));
    });
    setTimeout(() => {
      $("#BT5 .PDS .variant-selector.selected").click();
    }, 100);  

    $("#BT5 .PDS .show_flavors .variant-selector").click(function (e) {
      $("#BT5 .PDS .variant-selector").removeClass("selected");
      $(this).addClass("selected");

      // change servings
      let servingPriceOT = $(this).attr("serving-price-one-time");
      let servingPriceSubs = $(this).attr("serving-price-subs");
      $("#BT5 .PDS .block-wrapper-subs .prices .sub-text .subscription-serving-price").text(servingPriceSubs);
      $("#BT5 .PDS .block-wrapper-subs .prices .sub-text .serving-price").text(servingPriceOT);

      // change price
      let variantPrice = $(this).attr("price-one-time");
      let variantPriceSubs = $(this).attr("price-subs");
      $("#BT5 .PDS .prod-price .o-price").text(variantPriceSubs);
      $("#BT5 .PDS .prod-price .subscription-otp-price").text(variantPrice);
      $("#BT5 .PDS .prod-price.one-time").text(variantPrice);

      let varType = $(this).find(".radio-styles").attr("variant-type");
      let flavorTitle = $(this).parents(".variants-size").siblings(".flavor-options-block-wrap").find(".flavor_opt-input:checked").attr("flavor-title");

      console.log(`.flavor_opt-input.${varType}[flavor-title="${flavorTitle}"]`);
      if (flavorTitle != undefined) {
        $(this).parents(".variants-size").siblings(".flavor-options-block-wrap").find(`.flavor_opt-input.${varType}[flavor-title="${flavorTitle}"]`).click();
      } else {
        $(this).parents(".variants-size").siblings(".flavor-options-block-wrap").find(`.flavor_opt-input.${varType}`).first().click();
      }
      
      $(this).parents(".variants-size").siblings(".flavor-options-block-wrap").find(".flavor-option-bl").each(function () {
        if ($(this).attr("variant-opt") == varType) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      
      $("#BT5 .KXL-PDP .product-text .off-text .off-text-percent-value").text($(this).attr("off-price"));
      // calculate the price discount in percentage
      // let originalPrice = parseFloat(variantPrice.replace(/[^0-9.-]+/g, ""));
      // let discountedPrice = parseFloat(variantPriceSubs.replace(/[^0-9.-]+/g, ""));
      // let discountPercentage = ((originalPrice - discountedPrice) / originalPrice) * 100;
      // discountPercentage = Math.round(discountPercentage);
      // console.log(originalPrice, discountedPrice, discountPercentage);
      // $("#BT5 .KXL-PDP .product-text .off-text .off-text-percent-value").text(discountPercentage);
    });

    $("#BT5 .PDS .block-wrapper-subs").click(function(e){
      e.preventDefault();
      $("#BT5 .PDS .block-wrapper-subs").removeClass("selected");
      $(this).addClass("selected");
      $("#BT5 .PDS .atc-btn").text($("#BT5 .PDS .block-wrapper-subs.selected").attr('atc-text'));
    });
  
  
    $("#BT5 .PDS .atc-btn.show_flavors").click(function(e){
      e.preventDefault();
      // var variant_type = $("#BT5 .PDS .variant-selector.selected .radio-styles").attr("variant-type");
      let flavorOpt = null;

      $("#BT5 .PDS .flavor-options-block .flavor-option-bl").each(function () {
        if ($(this).find(".flavor_opt-input").is(":checked")) {
          flavorOpt = $(this).find(".flavor_opt-input").attr("id");
          console.log(flavorOpt);
        }
      });
      var subscripion_type = $("#BT5 .PDS .block-wrapper-subs.selected").attr("subs-type") + "-" + flavorOpt;


      var variant_ID;
      var selling_plan;
      var properties = {};


      console.log(subscripion_type);
      $("#BT5 .PDS .variant-types .variant-type").each(function(){
        // console.log(subscripion_type, $(this).attr("var-title"));
        if($(this).attr("var-title") === subscripion_type){
          variant_ID = $(this).attr("var-id");
          selling_plan = $(this).attr("selling-plan-id")
          console.log("variant_ID: " + variant_ID);
        }
      });

      
    $("#BT5 .PDS .dummy-flavor-options-block .dummy-flavor-option-bl input.dummy-flavor_opt-input").each(function () {
      if ($(this).is(":checked")) {
        // push flavorName to properties
        properties["Flavor"] = $(this).attr("flavor-title");
      }
    });
      
    $("#BT5 .PDS .dummy-size-only-block-wrapper .dummy-size-opt").each(function () {
      if ($(this).is(":checked")) {
        // push flavorName to properties
        console.log($(this).attr("size-type"));
        properties["Size"] = $(this).attr("size-type");
      }
    });


      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            quantity: 1,
            id: variant_ID,
            selling_plan: selling_plan,
            properties: properties
        },
        dataType: "json",
        success: function(data) {
          console.log(data.id);
        },
        error: function(data){
          console.log(data.responseText);
        }
      });
    });

    $("#BT5 .PDS .atc-btn.hide-flavors").click(function(e){
      e.preventDefault();
      var variant_type = $("#BT5 .PDS .variant-selector.selected").attr("variant-type");
      var subscripion_type = $("#BT5 .PDS .block-wrapper-subs.selected").attr("subs-type") + "-" + variant_type;
      var variant_ID;
      var selling_plan;
      var properties = {};


      console.log(subscripion_type);
      $("#BT5 .PDS .variant-types .variant-type").each(function(){
        console.log(subscripion_type);
        if($(this).attr("var-title") === subscripion_type){
          variant_ID = $(this).attr("var-id");
          selling_plan = $(this).attr("selling-plan-id")
          console.log("variant_ID: " + variant_ID);
        }
      });


      $("#BT5 .PDS .dummy-flavor-options-block .dummy-flavor-option-bl input.dummy-flavor_opt-input").each(function () {
        if ($(this).is(":checked")) {
          // push flavorName to properties
          properties["Flavor"] = $(this).attr("flavor-title");
        }
      });
      
      $("#BT5 .PDS .dummy-size-only-block-wrapper .dummy-size-opt").each(function () {
        if ($(this).is(":checked")) {
          // push flavorName to properties
          console.log($(this).attr("size-type"));
          properties["Size"] = $(this).attr("size-type");
        }
      });


      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: variant_ID,
          selling_plan: selling_plan,
          properties: properties
        },
        dataType: "json",
        success: function(data) {
          console.log(data.id);
        },
        error: function(data){
          console.log(data.responseText);
        }
      });
    });

    // accordion-block-style
    $("#BT5 .PDS .accordion-block-style .title-box").click(function(){
      $(this).find(".chevron").toggleClass("open");
      $(this).siblings(".accordion-desc").slideToggle();
    });

    // sticky button
    function updateKetoneProductBarMobile() {
      // Define the position at which you want to add the class 
      var scrollPositionMobile = 2200; // Change this value to your desired position  
      if ($(window).width() < 768 && $(window).scrollTop() > scrollPositionMobile) {
        // When the window is less than 768px and scrolled beyond the defined position, add a class to the element
        $('#BT5 .PDS .sticky_button a.button-styles').removeClass('d-none');
        $('#BT5 .PDS .sticky_button a.button-styles').addClass('d-block');
      } else {
        // If not met, or if the window is resized back above the defined position, remove the class
        $('#BT5 .PDS .sticky_button a.button-styles').addClass('d-none');
        $('#BT5 .PDS .sticky_button a.button-styles').removeClass('d-block');
      } 
    }
    // Call the function on page load
    updateKetoneProductBarMobile();
    // Call the function on window resize
    $(window).resize(updateKetoneProductBarMobile); 
    // Call the function on window scroll
    $(window).scroll(updateKetoneProductBarMobile);

    // open active slide in slider
    $("#BT5 .PDS .quick-add-image").click(function(){
      $(".quick-add-popup-PDS .product-images-quick-view-slider .carousel-item").removeClass("active");
      $(".quick-add-popup-PDS .product-images-quick-view-slider .carousel-item--"+$(this).attr("current-index")).addClass("active");
    });

    // slide Blocks
    $("#BT5 .ITBS .open-slide").click(function (e) { 
      e.preventDefault();
      $(".right-slide").removeClass("active-slide");
      $(this).siblings(".right-slide").addClass("active-slide");
    });
    $("#BT5 .ITBS .right-slide").click(function(e){
        e.preventDefault();
        var $specificDiv = $('.slide-width');
        if (!$specificDiv.is(e.target) && $specificDiv.has(e.target).length === 0) {
            $("#BT5 .ITBS .right-slide").removeClass("active-slide");
        }
    });
    $("#BT5 .ITBS .close-slide svg").click(function (e) { 
        console.log("Sssssss");
        e.preventDefault();
        $("#BT5 .ITBS .right-slide").removeClass("active-slide");
    });

    // Testimonials slider
    window.addEventListener("load", function () {
      const swiper = new Swiper(".client-testimonial-slider", {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          navigation: {
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
          },
          pagination: {
              el: ".swiper-pagination",
              type: "fraction"
          },
          breakpoints: {
              1024: {
                  slidesPerView: 3.3, 
                  spaceBetween: 30,
              },
          },
      });
  });

  // show and sticky button
  function updateKetoneProductBarMobile() {
    // Define the position at which you want to add the class 
    var scrollPositionMobile = 2200; // Change this value to your desired position  
    if ($(window).scrollTop() > scrollPositionMobile) {
      $('#BT5 .SBBLP, #BT5 .landing-page-sb-w').removeClass('d-none');
      $('#BT5 .SBBLP, #BT5 .landing-page-sb-w').addClass('d-block');
      // When the window is less than 768px and scrolled beyond the defined position, add a class to the element
    } else {
      // If not met, or if the window is resized back above the defined position, remove the class
      $('#BT5 .SBBLP, #BT5 .landing-page-sb-w').addClass('d-none');
      $('#BT5 .SBBLP, #BT5 .landing-page-sb-w').removeClass('d-block');
    } 
  }
  // Call the function on page load
  updateKetoneProductBarMobile();
  // Call the function on window resize
  $(window).resize(updateKetoneProductBarMobile); 
  // Call the function on window scroll
  $(window).scroll(updateKetoneProductBarMobile);



  // Ketone xl gird template
  let subsBox = $(".product-template-wrapper .product__info-wrapper input[name='sas-box'][id='sas-no']");
  function updateProductPrice(currentSelector) {
    console.log(currentSelector);
    let OTPrice = null;
    let SubsPrice = null;
    let subsVal = null;
    let varType = null;

    if ($(currentSelector).is(":checked")) {
      varType = $(currentSelector).attr('variant-type');
      OTPrice = $(currentSelector).attr("price-one-time");
      SubsPrice = $(currentSelector).attr("price-subs");

      console.log(varType);
      $("#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl").hide();
      $(`#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl[variant-opt='${varType}']`).show();

      subsVal = $(subsBox).is(":checked") ? "no" : "yes";
      console.log(subsVal);

      if (subsVal === "yes") {
          $(".fsv-product-price .original-price").text(SubsPrice);
          $(".fsv-custom-add-to-cart-btn .prod-price-in-ATC").text(SubsPrice);
          $(".fsv-product-price .original-price").append("<span class='sub-text'>/ Mo</span>");
      } else {
          $(".fsv-product-price .original-price").text(OTPrice);
          $(".fsv-custom-add-to-cart-btn .prod-price-in-ATC").text(OTPrice);
      }
    }
  }

  // Trigger change event on the flavor variant input
  $(".product-template-wrapper .variant-radios-block-css input.variant_opt-input").change(function () {
    updateProductPrice($(this));

    let variantFlavorTitle = $("#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl input.flavor_opt-input:checked").attr("flavor-title");
    let variantType = $(this).attr("variant-type");
    console.log(variantFlavorTitle, variantType);
    if (variantFlavorTitle != undefined) {
      $(`#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl input.flavor_opt-input[size-pack='${variantType}'][flavor-title="${variantFlavorTitle}`).click();
    } else {
      $(`#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl input.flavor_opt-input[size-pack='${variantType}']`).first().click();
    }
  });
  $(".prod-block-wrapper .sas-box .sas-options .sas-box-input-check").click(function () {
    console.log("Working");
    updateProductPrice($(".product-template-wrapper .variant-radios-block-css input.variant_opt-input:checked"));
  });
  // Trigger change event on the first variant input
  $(".product-template-wrapper .variant-radios-block-css input.variant_opt-input").first().trigger("change");


  // Trigger change event on the first dummy flavor input
  $("#BT5 .prod-block-dummy-flavors-wrapper .dummy-flavor-options-block .dummy-flavor-option-bl input").first().trigger("click");
  $("#BT5 .PDS .dummy-flavor-options-block .dummy-flavor-option-bl input.dummy-flavor_opt-input").first().trigger("click");


  // select dummy size block
  $("#BT5 .PDS .dummy-size-only-block-wrapper input.dummy-size-opt").change(function () {
    console.log("Dummy size block clicked");
    $(`#BT5 .PDS .dummy-size-only-block-wrapper`).removeClass("selected");
    $(this).parents(".dummy-size-only-block-wrapper").addClass("selected");
  });
  // Trigger change event on the first dummy size input
  $("#BT5 .PDS .dummy-size-only-block-wrapper input.dummy-size-opt").first().trigger("change");
  
  // flavor+size atc
  $(".product__info-container .fsv-custom-add-to-cart-btn button").click(function (e) { 
    let variant_id = null;
    let selling_plan_id = null;
    let properties = {};

    let flavorName = $("#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl input[name='flavor_opt']:checked").attr("flavor-name");

    let subsVal = $(subsBox).is(":checked") ? "no" : "yes";
    console.log(subsVal);
    if (subsVal === "yes") { 
      selling_plan_id = $(".all-variants-with-flvors-selector").attr("selling-plan");
      $(".all-variants-with-flvors-selector .subscription-variant-selector").each(function () {
        console.log($(this).attr("variant-title"), flavorName);
        if ($(this).attr("variant-title") == flavorName) {
          variant_id = $(this).attr("variant-id");
        }
      });
    } else {
      selling_plan_id = null;
      $(".all-variants-with-flvors-selector .one-time-variant-selector").each(function () {
        console.log($(this).attr("variant-title"), flavorName);
        if ($(this).attr("variant-title") == flavorName) {
          variant_id = $(this).attr("variant-id");
        }
      });
    }

    
    $("#BT5 .PDS .dummy-flavor-options-block .dummy-flavor-option-bl input.dummy-flavor_opt-input").each(function () {
      if ($(this).is(":checked")) {
        // push flavorName to properties
        properties["Flavor"] = $(this).attr("flavor-title");
      }
    });
      
    $("#BT5 .PDS .dummy-size-only-block-wrapper .dummy-size-opt").each(function () {
      if ($(this).is(":checked")) {
        // push flavorName to properties
        console.log($(this).attr("size-type"));
        properties["Size"] = $(this).attr("size-type");
      }
    });
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: $(".product-template-wrapper .product__info-wrapper .quantity .quantity__input").val(),
        id: variant_id,
        selling_plan: selling_plan_id,
        properties: properties
      },
      dataType: "json",
      success: function(data) {
        console.log(data.id);
      },
      error: function(data){
        console.log(data.responseText);
      }
    });
  });


  $("#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl input.flavor_opt-input").change(function () {
    $(this).parents(".varinats-flavors-blocks").find(".selected_flavor_text").text($(this).attr("flavor-original-title"))
  });
  $("#BT5 .varinats-flavors-blocks .flavor-options-block .flavor-option-bl input.flavor_opt-input").first().change();

  $("#BT5 .PDS .block-wrapper-subs").click(function () {
    let subsType = $(this).attr("subs-type");
    if (subsType == 'subscription') {
      $("#BT5 .PDS .three-column-quantity-selector .block-wrapper .block-inner .var-serving-text.one-time-serving").hide();
      $("#BT5 .PDS .three-column-quantity-selector .block-wrapper .block-inner .var-serving-text.subscription-serving").show();
    } else  if (subsType == 'one-time') {
      $("#BT5 .PDS .three-column-quantity-selector .block-wrapper .block-inner .var-serving-text.one-time-serving").show();
      $("#BT5 .PDS .three-column-quantity-selector .block-wrapper .block-inner .var-serving-text.subscription-serving").hide();
    }
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   let lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

//   if ('IntersectionObserver' in window) {
//       let lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
//           entries.forEach(function(video) {
//               if (video.isIntersecting) {
//                   for (let source in video.target.children) {
//                       let videoSource = video.target.children[source];
//                       if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
//                           videoSource.src = videoSource.dataset.src;
//                       }
//                   }
//                   video.target.load();
//                   video.target.classList.remove('lazy');
//                   lazyVideoObserver.unobserve(video.target);
//               }
//           });
//       });

//       lazyVideos.forEach(function(lazyVideo) {
//           lazyVideoObserver.observe(lazyVideo);
//       });
//   }
// });

document.addEventListener("DOMContentLoaded", function() {
  var videos = document.querySelectorAll("video");
  videos.forEach(function(video) {
    video.setAttribute("preload", "none");
  });


  // Enable tooltip
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
});